import { FeatureFlag, FeatureFlagEnum } from "@/types";

import { axios } from "../axios.instance";

export type GetFeatureFlagByNameRequest = {
  name: FeatureFlagEnum;
};

export type GetFeatureFlagByNameResponse = FeatureFlag;

export const getFeatureFlag = async (body: GetFeatureFlagByNameRequest): Promise<GetFeatureFlagByNameResponse> => {
  const { data } = await axios.get(`/feature-flags/${body.name}`);

  return data;
};
